import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { SKILL_REPOSITORY } from '../../core';
import { SKILL_API } from '../data-sources';
export var SkillWebRepository = /*#__PURE__*/function () {
  function SkillWebRepository(skillApi) {
    _classCallCheck(this, SkillWebRepository);

    this.skillApi = skillApi;
  }

  _createClass(SkillWebRepository, [{
    key: "getSkills",
    value: function () {
      var _getSkills = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError, paginationResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.skillApi.getSkills(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                paginationResponse = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(paginationResponse));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSkills(_x) {
        return _getSkills.apply(this, arguments);
      }

      return getSkills;
    }()
  }, {
    key: "getSkillById",
    value: function () {
      var _getSkillById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var responseOrError, skill;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.skillApi.getSkillById(id);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                skill = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(skill));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSkillById(_x2) {
        return _getSkillById.apply(this, arguments);
      }

      return getSkillById;
    }()
  }]);

  return SkillWebRepository;
}();
export var skillWebRepositoryProvider = {
  provide: SKILL_REPOSITORY,
  useFactory: function useFactory(skillApi) {
    return new SkillWebRepository(skillApi);
  },
  inject: [SKILL_API]
};